export default __webpack_public_path__ + "static/media/04.9abe2d1c.jpg";